class SideDrawer extends HTMLElement {
  constructor() {
    super();

    const thisElement = this;

    //Toggle event listeners
    this.addEventListener("drawer-toggle", function (e) {
      if (this.classList.contains("active")) {
        document.querySelector('side-drawer-toggle.header__menu-toggle').classList.remove('active');
        thisElement.close(this);

        const searchInput = this.querySelector('.js-search-input');

        if (!searchInput) return;

        searchInput.blur();
      } else {
        thisElement.open(this);
        
        if (e.detail) {
          if (e.detail.search) {
            const searchInput = this.querySelector('.js-search-input');

            if (!searchInput) return;

            this.addEventListener('transitionend', () => {
              searchInput.focus();
            }, { once: true })
          }
        }
      }
    });

    //Key up and body click events
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.onBodyClick = this.handleBodyClick.bind(this);

    //set drawer height
    this.drawerHeight();

    //add event listener for resize
    window.addEventListener("resize", this.drawerHeight);
  }

  //Open drawer
  open(drawer) {
    this.classList.add("active");
    document.body.classList.add("shadow");

    const drawers = document.querySelectorAll(".js-drawer");
 
    drawers.forEach((el) => {
      el.classList.add("hide-content");
    });

    this.classList.remove("hide-content");

    this.addEventListener(
      "transitionend",
      () => {
        drawer.focus();
        trapFocus(drawer);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });
  }

  //Close drawer
  close() {
    this.classList.remove("active");

    const level = this.getAttribute("data-level");

    if (level) {
      const drawers = document.querySelectorAll(
        `.js-drawer.js-drawer-level-${level - 1}`
      );

      drawers.forEach((el) => {
        el.classList.remove("hide-content");
      });
    }

    const activeDrawers = document.querySelectorAll("side-drawer.active");

    if (!activeDrawers.length) {
      document.body.classList.remove("shadow");

      document.body.removeEventListener("click", this.onBodyClick, {
        passive: true,
      });
    }

    const activeModal = document.querySelector('.modal--active');
    if (activeModal) activeModal.classList.remove('modal--active');
    removeTrapFocus(this);
  }

  //Body click event to close drawer
  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this &&
      !target.closest("side-drawer") &&
      !target.closest("side-drawer-toggle")
    ) {
      document.querySelector('side-drawer-toggle.header__menu-toggle').classList.remove('active');
      this.close();
    }
  }

  //recalculate height of drawer when viewport changes
  drawerHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }
}

customElements.define("side-drawer", SideDrawer);
